import { createStyles } from 'antd-style';
import { hoverBg1 } from 'constants/color';
import { drawerWidth } from 'store/constant';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      padding: 26px;
      flex: 0 0 ${drawerWidth}px;
      min-height: 100vh;
      max-height: 100vh;
      overflow: visible;
      position: unset;
      left: 0px;

      right: unset;
      background-color: transparent !important;
      .ant-layout-sider-light {
        background-color: rgba(246, 246, 246, 1) !important;
      }
    `,
    wrap: css`
      height: 100%;
      margin-top: -0.1px;
      padding-top: 0.1px;
      background: #fff;
      border-radius: 20px;
    `,
    menu: css`
      background-color: #fff;
      .ant-menu-item {
        margin: 4px 0;
      }
    `,
    menuContainer: css`
      max-height: calc(100% - 70px);
      padding: 0 10px;
      /* padding: 12px; */
      overflow: auto;
      box-sizing: border-box;
    `,
    menuWrap: css``,
    title: css`
      font-size: 14px;
      font-weight: bold;
      margin-top: 20px;
      margin-bottom: 10px;
      padding-left: 15px;
      color: rgba(102, 102, 102, 1);
    `
  };
});

export const useMenuItemStyles = createStyles(({ token, css }, props: { isActive: boolean }) => {
  const { isActive } = props;
  return {
    menuItem: css`
      margin-top: 10px;
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      background-color: ${isActive ? 'rgba(255, 102, 51, 0.1)' : 'transparent'};
      color: ${isActive ? token.colorPrimary : 'rgba(117, 123, 140, 1)'};
      &:hover {
        background-color: rgba(255, 102, 51, 0.1);
      }
      &:active {
        opacity: 0.9;
      }
    `,
    subMenuTitle: css`
      font-size: 14px;
      margin-left: 8px;
    `
  };
});
